import { Dropdown, Menu, Pagination } from 'antd'
import debounce from 'lodash.debounce'
import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useAccount } from 'wagmi'

import EmptyConnect from '../../../components/empty-connect'
import { BASE_SCAN } from '../../../constants'
import { useHookAccount } from './storeAccount'

const PENDING = 1
const SUCCESS = 2
const FAIL = 3
const DEFAULT_PAGE_INDEX = 1
const DEFAULT_PAGE_SIZE = 10

interface ISearchHistoryParams {
  ownerAddress?: string
  pageSize?: number
  pageIndex?: number
  keySearch?: string
  type?: number
  status?: number
}

const HistoryComponent = () => {
  const { address } = useAccount()
  //const address = '0x6e6b8a5055b2ca455362b6e4042b7cbe10aecd95'

  const [state, actions] = useHookAccount()
  const [pageIndex, setPageIndex] = useState(DEFAULT_PAGE_INDEX)
  const [pageSize, setPageSize]: any = useState(DEFAULT_PAGE_SIZE)
  const [listHis, setListHis]: any = useState([])
  const [status, setStatus]: any = useState(0)
  const [textType, setTextType]: any = useState(0)
  const [totalItem, setTotalItem]: any = useState(0)
  const [valueSearch, setValueSearch]: any = useState('')
  const [loadingData, setLoadingData]: any = useState(true)

  function gotoHash(txHash: any): void {
    window.open(`${BASE_SCAN}/tx/${txHash}`)
  }

  const onChangePagination = (page: any) => {
    setLoadingData(true)
    setPageIndex(page)
    handleSearchCall({
      keySearch: valueSearch,
      pageIndex: page - 1
    })
  }

  const items: any = [
    {
      label: (
        <div
          onClick={() => onClickSelectStatus(0)}
          className='type-his w-auto all'
        >
          All Status
        </div>
      ),
      key: '0'
    },
    {
      label: (
        <div
          onClick={() => onClickSelectStatus(2)}
          className='type-his w-auto success'
        >
          Success
        </div>
      ),
      key: '1'
    },
    {
      label: (
        <div
          onClick={() => onClickSelectStatus(1)}
          className='type-his w-auto pending'
        >
          Pending
        </div>
      ),
      key: '2'
    },
    {
      label: (
        <div
          onClick={() => onClickSelectStatus(3)}
          className='type-his w-auto fail'
        >
          Fail
        </div>
      ),
      key: '3'
    }
  ]

  const onClickSelectStatus = (type: any) => {
    if (status !== type) {
      setLoadingData(true)
      setPageIndex(DEFAULT_PAGE_INDEX)
      setStatus(type)
      handleSearchCall({
        status: type,
        pageIndex: DEFAULT_PAGE_INDEX - 1
      })
    }
  }

  const onClickType = (type: any) => {
    if (textType !== type) {
      setLoadingData(true)
      setPageIndex(DEFAULT_PAGE_INDEX)
      setTextType(type)
      handleSearchCall({
        type: type,
        pageIndex: DEFAULT_PAGE_INDEX - 1
      })
    }
  }

  function renderText(status: any) {
    switch (status) {
      case PENDING:
        return 'Pending'
      case SUCCESS:
        return 'Success'
      case FAIL:
        return 'Fail'
      default:
        return '--'
    }
  }

  function renderClass(status: any) {
    switch (status) {
      case PENDING:
        return 'status-pending'
      case SUCCESS:
        return 'status-success'
      case FAIL:
        return 'status-fail'
      default:
        return 'status-pending'
    }
  }

  const renderClassType = (value: any) => {
    switch (value) {
      case 0:
        return ''
      case 2:
        return 'bg-success'
      case 1:
        return 'bg-pending'
      case 3:
        return 'bg-fail'
      default:
        return ''
    }
  }

  const renderStatus = (value: any) => {
    switch (value) {
      case 0:
        return 'All Status'
      case 1:
        return 'Pending'
      case 2:
        return 'Success'
      case 3:
        return 'Fail'
      default:
        return 'All Status'
    }
  }

  const renderType = (value: any) => {
    switch (value) {
      case 0:
        return 'All Type'
      case 1:
        return 'Staking'
      case 2:
        return 'Loans'
      case 3:
        return 'Vesting'
      case 4:
        return 'PTO'
      default:
        return 'All Type'
    }
  }

  const menu = (
    <Menu>
      <Menu.Item>
        <div onClick={() => onClickType(0)} className='type-his w-auto all'>
          All type
        </div>
      </Menu.Item>
      <Menu.Item>
        <div onClick={() => onClickType(1)} className='type-his w-auto all'>
          Staking
        </div>
      </Menu.Item>
      <Menu.Item>
        <div onClick={() => onClickType(2)} className='type-his w-auto all'>
          Loans
        </div>
      </Menu.Item>
      <Menu.Item>
        <div onClick={() => onClickType(3)} className='type-his w-auto all'>
          Vesting
        </div>
      </Menu.Item>
      <Menu.Item>
        <div onClick={() => onClickType(4)} className='type-his w-auto all'>
          PTO
        </div>
      </Menu.Item>
    </Menu>
  )

  const getListHis = async (paramsSearch?: ISearchHistoryParams) => {
    try {
      const params = {
        ownerAddress: address || '',
        pageSize: pageSize,
        pageIndex: pageIndex - 1,
        keySearch: valueSearch,
        type: textType,
        status: status,
        ...(paramsSearch || {})
      }

      // console.log(
      //   'current params, params----------------',
      //   {
      //     ownerAddress: address || '',
      //     pageSize: pageSize,
      //     pageIndex: pageIndex - 1,
      //     keySearch: valueSearch,
      //     type: textType,
      //     status: status
      //   },
      //   params
      // )

      await actions
        .getHistory(params)
        .then((res: any) => {
          setListHis(res?.data)
          setTotalItem(res?.totalCount)
          setLoadingData(false)
        })
        .catch((err: any) => {
          console.log('err', err)
          setListHis([])
          setLoadingData(false)
        })
    } catch (error) {
      console.log('error', error)
      setListHis([])
      setLoadingData(false)
    }
  }

  useEffect(() => {
    handleSearchCall()
  }, [address])

  function handleSearch(e: any) {
    setLoadingData(true)
    setPageIndex(DEFAULT_PAGE_INDEX)
    setValueSearch(e?.target?.value)
    debouncedSearch({
      keySearch: e?.target?.value
    })
  }

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      setPageIndex(DEFAULT_PAGE_INDEX)
      handleSearchCall()
    }
  }

  const handleSearchCall = (paramsSearch?: ISearchHistoryParams) => {
    // console.log('handleSearchCall params-----------------', paramsSearch)
    if (address) {
      getListHis(paramsSearch)
    } else {
      setLoadingData(false)
      setListHis([])
    }
  }

  const debouncedSearch: any = debounce(handleSearchCall, 1000)

  // useEffect(() => {
  //   console.log('debouncedSearch-------------------')
  //   return () => {
  //     debouncedSearch.cancel()
  //   }
  // }, [debouncedSearch])

  return (
    <>
      <div className='mar-b-100-p2p position-relative'>
        {address === null || !address ? (
          <>
            <EmptyConnect />
          </>
        ) : (
          <>
            <div className='grow-wrap'>
              <div className='wrap-left his'>
                <div className='list-filter-profile res res-mobile'>
                  <div className='row-right'>
                    <div className='row-search'>
                      <input
                        onKeyDown={handleKeyDown}
                        value={valueSearch}
                        onChange={(e) => handleSearch(e)}
                        placeholder='Search by TxID'
                        type='text'
                      />
                      <img src='/images/user/search.png' alt='' />
                    </div>
                    <div className='group-his-left'>
                      <div className='status-filter'>
                        <Dropdown
                          className={`btn-status`}
                          overlayClassName='dropdown-type'
                          overlay={menu}
                          trigger={['click']}
                          placement='bottomRight'
                        >
                          <a onClick={(e) => e.preventDefault()}>
                            {renderType(textType)}
                          </a>
                        </Dropdown>
                      </div>
                      <div className='status-filter'>
                        <Dropdown
                          className={`btn-status ${renderClassType(status)}`}
                          overlayClassName='dropdown-type'
                          menu={{
                            items
                          }}
                          placement='bottomRight'
                          trigger={['click']}
                        >
                          <a onClick={(e) => e.preventDefault()}>
                            {renderStatus(status)}
                          </a>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                </div>
                {isMobile ? (
                  <>
                    <div className='list-mobile-history'>
                      {listHis.length > 0 ? (
                        <>
                          {listHis.map((item: any, index: any) => (
                            <>
                              <div className='row-item-mobile'>
                                <div className='item'>
                                  <div className='txt-l'>Time</div>
                                  <div className='txt-right'>{item?.date}</div>
                                </div>
                                <div className='item'>
                                  <div className='txt-l'>Type</div>
                                  <div className='txt-right'>{item?.type}</div>
                                </div>
                                <div className='item'>
                                  <div className='txt-l'>Amount</div>
                                  <div className='txt-right'>
                                    {item?.amountType === 1 ? (
                                      <span className='main-color-amount'>
                                        +{item?.amount}
                                      </span>
                                    ) : item?.amountType === -1 ? (
                                      <span className='main-color-negative'>
                                        -{item?.amount}
                                      </span>
                                    ) : (
                                      <>--</>
                                    )}
                                  </div>
                                </div>
                                <div className='item'>
                                  <div className='txt-l'>Asset</div>
                                  <div className='txt-right'>{item?.asset}</div>
                                </div>
                                <div className='item'>
                                  <div className='txt-l'>TxID</div>
                                  <div className='txt-right'>
                                    <div
                                      className='row-link'
                                      onClick={() => gotoHash(item?.txHash)}
                                    >
                                      {item?.txHash.slice(0, 5)}...
                                      {item?.txHash.slice(-5)}{' '}
                                      <img src='/images/user/link.png' alt='' />
                                    </div>
                                  </div>
                                </div>
                                <div className='item'>
                                  <div className='txt-l'>Status</div>
                                  <div className='txt-right'>
                                    <div className={renderClass(item?.status)}>
                                      {renderText(item?.status)}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ))}
                          {totalItem > pageSize ? (
                            <tr>
                              <td colSpan={6}>
                                <div className='pagination-his'>
                                  <Pagination
                                    current={pageIndex}
                                    defaultPageSize={pageSize}
                                    onChange={onChangePagination}
                                    total={totalItem}
                                  />
                                </div>
                              </td>
                            </tr>
                          ) : null}
                        </>
                      ) : (
                        <div className='box-no-data-stake'>
                          <img
                            className='img-empty'
                            src='/images/no-data-cus.png'
                            alt=''
                          />
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <div className='main-table-row'>
                      <table cellSpacing='0' className='main-table'>
                        <thead>
                          <tr>
                            <th>Time</th>
                            <th>Type</th>
                            <th>Amount</th>
                            <th>Asset</th>

                            <th>TxID</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingData ? (
                            <tr key={Math.random()}>
                              <td className='nodata-loading' colSpan={6}>
                                <div className='load-3'>
                                  <div className='line'></div>
                                  <div className='line'></div>
                                  <div className='line'></div>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            <>
                              {listHis.length > 0 ? (
                                <>
                                  {listHis.map((item: any, index: any) => (
                                    <tr key={index}>
                                      <td>{item?.date}</td>
                                      <td>{item?.type}</td>
                                      <td>
                                        {item?.amountType === 1 ? (
                                          <span className='main-color-amount'>
                                            +{item?.amount}
                                          </span>
                                        ) : item?.amountType === -1 ? (
                                          <span className='main-color-negative'>
                                            -{item?.amount}
                                          </span>
                                        ) : (
                                          <>--</>
                                        )}
                                      </td>
                                      <td>{item?.asset}</td>

                                      <td>
                                        <div
                                          className='row-link'
                                          onClick={() => gotoHash(item?.txHash)}
                                        >
                                          {item?.txHash.slice(0, 5)}...
                                          {item?.txHash.slice(-5)}{' '}
                                          <img
                                            src='/images/user/link.png'
                                            alt=''
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div
                                          className={renderClass(item?.status)}
                                        >
                                          {renderText(item?.status)}
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                  {totalItem > pageSize ? (
                                    <tr>
                                      <td colSpan={6}>
                                        <div className='pagination-his'>
                                          <Pagination
                                            current={pageIndex}
                                            defaultPageSize={pageSize}
                                            onChange={onChangePagination}
                                            total={totalItem}
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  ) : null}
                                </>
                              ) : (
                                <tr key={Math.random()}>
                                  <td className='nodata' colSpan={6}>
                                    <div className='box-no-data-stake'>
                                      <img
                                        className='img-empty'
                                        src='/images/no-data-cus.png'
                                        alt=''
                                      />
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  )
}
export default HistoryComponent
